(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const swapProductWishlistHeart = (widget) => {
    const button = widget.querySelector('.Vtl-WishlistButton__WishlistIconButton');
    if (!button) return;

    if (button.querySelector('.Vtl-Spinner')) {
      widget.querySelectorAll('svg').forEach((svg) => svg.remove());
      return;
    }

    const source = document.querySelector('template[data-homi-wishlist-icon]')?.content?.querySelector('svg');
    if (!source) return;

    const state = /\badded\b/i.test(button.getAttribute('title') || '') ? 'added' : '';
    const svgs = [...widget.querySelectorAll('svg')];
    const keeper = svgs.find((svg) => svg.getAttribute('data-homi-heart') === state);

    svgs.forEach((svg) => {
      if (svg !== keeper) svg.remove();
    });

    const wrap = widget.querySelector('.Vtl-WishlistButton__IconWrapper');
    if (keeper) {
      if (wrap && keeper.parentElement !== wrap) wrap.prepend(keeper);
      return;
    }

    const next = source.cloneNode(true);
    next.setAttribute('data-homi-heart', state);

    if (state === 'added') {
      const path = next.querySelector('path');
      const outline = path?.getAttribute('d') || '';
      const solid = outline.split(/Z(?=m)/i)[0];
      if (path && solid && solid !== outline) path.setAttribute('d', `${solid}Z`);
    }

    if (wrap) {
      wrap.prepend(next);
      return;
    }

    button.prepend(next);
  };

  const placeProductWishlist = () => {
    const details = document.querySelector('.product-details');
    const widget = document.querySelector('.Vtl-WishlistIcon__ProductPageWrapper');
    const anchor = details && details.querySelector('.buy-buttons-block');

    if (!details || !widget || !anchor) return false;

    if (widget.previousElementSibling !== anchor) anchor.after(widget);
    swapProductWishlistHeart(widget);

    return widget.previousElementSibling === anchor;
  };

  const watchProductWishlist = () => {
    if (!document.querySelector('.product-details')) return;

    const observer = new MutationObserver(() => {
      placeProductWishlist();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    placeProductWishlist();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchProductWishlist);
  } else {
    watchProductWishlist();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-copyright"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-scroll-top')) {
    class FooterScrollTop extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.onClick = () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        };
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }
    }

    customElements.define('footer-scroll-top', FooterScrollTop);
  }
  } catch(e) { console.error(e); }
})();

})();
